var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGlobalProvide3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 40,
  height: 38,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#408BFC",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m1.85 14.936 17.554-8.699a1.34 1.34 0 0 1 1.192 0l17.554 8.699-17.63 7.392c-.332.14-.707.14-1.04 0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#408BFC",
  strokeWidth: 2,
  d: "M30.667 18.5v5.645c0 .9-.5 1.728-1.3 2.155a19.92 19.92 0 0 1-18.735 0 2.44 2.44 0 0 1-1.299-2.154V18"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#408BFC",
  d: "M34.667 16.357H36v12.554c0 .365-.298.66-.667.66a.664.664 0 0 1-.666-.66z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#408BFC",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "m34.718 34.777.615-2.44.616 2.44a.33.33 0 0 1-.323.41h-.585a.33.33 0 0 1-.323-.41Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  stroke: "#408BFC",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m12 14.832 4.923-2.44"
})));
export default SvgGlobalProvide3;